import React from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import './DashboardMap.css';
import "leaflet/dist/leaflet.css";

const MapComponent = ({ siteCodes }) => {
  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      maxZoom={10}
      minZoom={1}
      maxBounds={[
        [-85, -180], // Southwest corner
        [85, 180], // Northeast corner
      ]}
      style={{ height: "85%", width: "100%" }}
    >
      <TileLayer
        url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
      />
      {siteCodes.map((site, index) => ( ( ((site.latitude !== 0) || (site.longitude !== 0 )) ? (
        <CircleMarker
          key={index}
          center={[site.latitude, site.longitude]}
          fillColor={'cyan'}
          fillOpacity={1}
          radius={7}
          className="custom-circle-marker"
        >
          <Popup>
            <span className="event-title-text">{site.eventTitle}</span><br />
            <span className="event-format-text">{site.city}</span>
          </Popup>
        </CircleMarker>
      ) : "")))}
    </MapContainer>
  );
};

export default MapComponent;